/**
 * GovConfiguracoes — hub geral de ajustes com atalhos para os submódulos.
 */
import { Link } from "react-router-dom";
import { GearSix, LifebuoyIcon, Buildings, WhatsappLogo, ShieldCheck, ArrowRight } from "@phosphor-icons/react";

const SETTINGS = [
  { to: "/gov/operacao",     icon: LifebuoyIcon, title: "Operação do Agente", desc: "Nome do órgão, identidade da IA, tom de voz." },
  { to: "/gov/secretarias",  icon: Buildings,    title: "Secretarias & SLA",  desc: "Mapa dos departamentos, responsáveis e prazos." },
  { to: "/gov/integracoes",  icon: WhatsappLogo, title: "WhatsApp & Integrações", desc: "Z-API, e-SIC, ERP municipal, sistemas legados." },
  { to: "/gov/lgpd",         icon: ShieldCheck,  title: "LGPD & Compliance",  desc: "Consentimento, direitos do titular, auditoria." },
];

export default function GovConfiguracoes() {
  return (
    <div data-testid="gov-configuracoes-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.22em] text-emerald-700/70 font-medium mb-1">Configurações</div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight flex items-center gap-2">
          <GearSix size={22} className="text-emerald-700" />
          Ajustes Gerais
        </h1>
        <p className="text-[12.5px] text-slate-500 mt-0.5">Central de configurações do portal institucional.</p>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {SETTINGS.map(s => {
          const Icon = s.icon;
          return (
            <Link
              key={s.to}
              to={s.to}
              data-testid={`config-shortcut-${s.to.split("/").pop()}`}
              className="group rounded-xl border border-slate-200 bg-white p-4 flex items-center gap-3 hover:border-emerald-400 hover:shadow-sm transition-all"
            >
              <div className="w-11 h-11 rounded-lg bg-emerald-700/10 border border-emerald-600/20 grid place-items-center shrink-0">
                <Icon size={20} className="text-emerald-700" weight="regular" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-slate-900 text-[14px]">{s.title}</div>
                <div className="text-[11.5px] text-slate-500 leading-relaxed">{s.desc}</div>
              </div>
              <ArrowRight size={14} className="text-slate-400 group-hover:text-emerald-700 shrink-0" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
